import { h } from "preact";
import styled from "styled-components";

import LeftSection from "./components/LeftSection";
import RightSection from "./components/RightSection";
import SmallSection from "./components/SmallSection";

const ContainerAd = styled.div`
  width: 730px;
  height: 310px;
  margin: 0 auto;

  #desktop {
    display: flex;
    height: inherit;
  }

  #mobile {
    display: none;
    height: inherit;
  }

  @media (max-width: 729px) {
    width: 100%;
    height: 370px;
    #desktop {
      display: none;
    }
    #mobile {
      display: flex;
    }
  }
`;

const PremiumAd = (props) => {
  return (
    <ContainerAd>
      <div id="desktop">
        <LeftSection {...props}/>
        <RightSection {...props}/>
      </div>
      <div id="mobile">
        <SmallSection {...props} />
      </div>
    </ContainerAd>
  );
}

export default PremiumAd;
